export var DELIVERY_METHOD_TRANSLATION = {
    delivery_type_step: {
        delivery_type: 'Define o tipo de entrega',
        select_option: 'Selecione o melhor método de entrega para seus pedidos',
        recommended: 'Recomendado',
        commission: 'De comissão',
        iva: '+ IVA',
        discountCode: {
            placeHolder: 'Digite o código',
            invalidCode: 'Código de referência inválido',
            failed: 'Erro ao processar. Tente novamente mais tarde.',
        },
        discount_coupon: 'Cupom de desconto',
        discount_applied: 'Desconto aplicado',
        discount_coupon_applied: 'Cupom de desconto aplicado!',
        do_you_have_refrence_code: 'Cupom de dVocê tem um código de referência? Você pode se inscrever abaixo',
        'change-to-selected-plan': 'Verifique as alterações no plano selecionado',
        apply: 'Aplicar',
    },
    commercialPlans: {
        fullService: {
            title: 'A Rappi entrega',
            benefits: {
                AR: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                BR: [
                    'Parceiro vende e a entrega será via entregadores independentes  cadastrados na  Rappi.',
                    '<b>Tarifas de</b> 3,5% sobre os pedidos.',
                    '<b>Repasse</b> quinzenal.',
                    '<b>Contrato:</b> Duração de {{periods}} meses e poderá  rescindir com aviso prévio de 90 dias.',
                    '<b>O Parceiro deverá</b> Manter o cardápio atualizado com  preços iguais a outros canais de vendas, autorizando a Rappi proceder 10% de descontos.',
                ],
                CL: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                CO: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                CR: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                MX: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                EC: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                PE: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
                UY: [
                    '<b>Todo lo del plan Entrega Propia</b',
                    'Entrega segura y realizada por Rappi con repartidores capacitados',
                    'Rastreo de repartidor en tiempo real',
                    'Acceso a programa de beneficios',
                    'Estimamos el tiempo de entrega con precisión',
                    'Gestión del tiempo de preparación y entrega',
                ],
            },
            discounts: '<b>0% de comissão </b> nos primeiros {{days}} días <br> para o uso da plataforma',
        },
        marketplace: {
            title: 'O restaurante entrega',
            benefits: {
                AR: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                BR: [
                    'Parceiro vende na Rappi e realiza a entrega por conta própria.',
                    '<b>Tarifas de</b> 3,5% sobre os pedidos.',
                    '<b>Repasse</b> quinzenal.',
                    '<b>Contrato:</b> Duração de {{periods}} meses e poderá rescindir com aviso prévio de 90 dias.',
                    '<b>O Parceiro deverá</b> Manter o cardápio atualizado com  preços iguais a outros canais de vendas, autorizando a Rappi proceder 10% de descontos.',
                ],
                CL: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                CO: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                CR: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                MX: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                EC: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                PE: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
                UY: [
                    'Tu restaurante es encargado de la entrega',
                    'Tu restaurante disponible en la app de Rappi',
                    'Envío gratis para clientes Rappi Prime',
                    'Servicio opcional de reparto pagado por entrega',
                ],
            },
            discounts: '<b>0% de comissão </b> nos primeiros {{days}} días <br> para o uso da plataforma',
        },
    },
};
